import React from 'react';
import { Button } from '@material-ui/core';
import LogoutIcon from '../../assets/logout.svg';
import useLogoutStyles from './portal-logout.styles';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../../stores/async/identity-async-actions';

interface LogoutProps {
  showButton?: boolean
}

const PortalLogout: React.FC<LogoutProps> = (props): JSX.Element => {
  const classes = useLogoutStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
;
  const onLogout = () => {
    dispatch(logout())
    navigate('/welcome');
  }

  return (
    <>
      <Button
        disableRipple
        className={props.showButton ? null : classes.button}
        onClick={onLogout}
        data-testid="app-logout"
        data-cy="logout-btn"
        color={props.showButton ? 'primary' : 'secondary'}
        variant={props.showButton ? 'contained' : 'text'}
      >
        <span className={classes.logoutBtnText} style={{ color: props.showButton ? 'white' : 'inherit' }}>Log Out</span>
        {!props.showButton && <img src={LogoutIcon} alt="Logout" className={classes.icon} />}
      </Button>
    </>
  );
};

export default PortalLogout;
